import { render, staticRenderFns } from "./GruposFormCriarAlterar.vue?vue&type=template&id=fbe78fb4&"
import script from "./GruposFormCriarAlterar.vue?vue&type=script&lang=ts&"
export * from "./GruposFormCriarAlterar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VForm,VTextField})
